import { api } from './client';

export type Dog = {
  id: number;
  name: string;
  breed?: string;
  age?: number;
  weight?: number;
  body_condition?: string;
  meals_per_day?: number;
  allergies?: string[];
  [key: string]: any;
};

export async function getDogs(): Promise<Dog[]> {
  const res = await api.get('/dogs');
  return res.data;
}

export async function createDog(params: {
  name: string;
  breed?: string;
  age?: number;
  weight?: number;
  body_condition?: string;
  meals_per_day?: number;
  allergies?: string[];
}): Promise<Dog> {
  const res = await api.post('/dogs', params);
  return res.data;
}

export async function updateDog(id: number, params: {
  name?: string;
  breed?: string;
  age?: number;
  weight?: number;
  body_condition?: string;
  meals_per_day?: number;
  allergies?: string[];
}): Promise<Dog> {
  const res = await api.patch(`/dogs/${id}`, params);
  return res.data;
}

export async function deleteDog(id: number): Promise<void> {
  await api.delete(`/dogs/${id}`);
}
